import React from "react"

export class ClientErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError && this.props.fallBack) {
      return this.props.fallBack;
    }

    return this.props.children; 
  }

  componentDidMount() {
    if (process.env.NODE_ENV === 'development') {
      doNotShowFullPageReactErrors();
    }
  }
}

function doNotShowFullPageReactErrors() {
  const style = document.createElement('style');
  document.head.appendChild(style);
  style.sheet.insertRule('body iframe {position: relative !important}');
}

